// extracted by mini-css-extract-plugin
export default {"wrapper":"SearchSelector_wrapper__DVS7H","dropDown":"SearchSelector_dropDown__mxEp4","topic":"SearchSelector_topic__9n29+"};